import "core-js/modules/es.array.reduce.js";
const context = require.context('@/api/modules/', false, /\.js$/);
const modules = context.keys().reduce((acc, key) => {
  const name = key.replace(/\.\/|\.js/g, '');
  acc = {
    ...acc,
    ...{
      [name]: context(key)
    }
  };
  return acc;
}, {});
export default modules;